import { createColumns, Text, UseTableStateParams } from '@vtex/admin-ui'
import { FormattedMessage } from 'react-intl'
import { Item } from 'typings'
import { messages } from './messages'

export function SellerNameHeader() {
  return <FormattedMessage {...messages.drawer.sellerName} />
}

export function SellerIdHeader() {
  return <FormattedMessage {...messages.drawer.sellerId} />
}

export const columns: UseTableStateParams<Item>['columns'] = createColumns([
  {
    id: 'name',
    width: '1fr',
    header: SellerNameHeader,
    resolver: {
      type: 'plain',
      render: ({ data }) => <Text variant="action1">{data}</Text>,
    },
  },
  {
    id: 'id',
    width: '1fr',
    header: SellerIdHeader,
    resolver: {
      type: 'plain',
      render: ({ data }) => <Text variant="body">{data}</Text>,
    },
  },
])

export const items: Item[] = Array.from({ length: 50 }, (_, i) => ({
  name: `Seller ${`${i}`.repeat(i + 1)}`,
  id: `seller-${`${i}`.repeat(i + 1)}`,
}))
